import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import * as R from "ramda";

import * as Loadings from '../../../constants/loadings/backoffice/dossiers';
import { setFilterGlobal } from '../../../actions/backoffice/dossiers';
import { EnvoisProfile } from '../_common/EnvoisProfile';
import { LoadingState } from '../../../_common/loadingState';

import { DossiersFilter } from './filter';
import { DossiersPagination } from './pagination';

export const DossiersMain = ({ dossierState, partnerState, partners, pageSearch, setPageSearch, routerQuery }) => {
	const dispatch = useDispatch();

	const [usersToDisplay, setUsersToDisplay] = useState(dossierState.dossiers);
	const [partnersToDisplay, setPartnersToDisplay] = useState(partners);
	const statusOptionsRoute = { anticipaNotAccepted: "N'a pas accepté", facilitaNotAccepted: "Non commencé", anticipaOngoing: "En cours", facilitaOngoing: "En cours", anticipaFinished: "Complété", anticipaYearAndMore: "Contrat d'un an", anticipaClosed: "Clôture", all: 'Tous les dossiers', facilitaSending: 'A envoyer', facilitaOvertime: "Courriers générés" };
	const statusOptions = { notStarted: "Non commencé", notAccepted: "En cours", ongoing: "En cours", finished: "Complété", yearAndMore: "Contrat d'un an", all: 'Tous les dossiers', sending: 'A envoyer', overtime: "Courriers générés", archived: "Archivé" };
	const searchRef = useRef();

	useEffect(() => {
		if (!R.isNil(searchRef.current) && pageSearch !== "") {
			searchRef.current.focus();
		}
	}, [pageSearch]);

	useEffect(() => {

		let temp = partners;
		setPartnersToDisplay(temp);

		// if ((!R.isNil(pagePartner) || pagePartner !== "") && R.isNil(dossierState.globalFilters.partner.id) && !R.isNil(dossierState.partners)) {

		// 	const findPartner = dossierState.partners.find(p => p.id === pagePartner);
		// 	if (!R.isNil(findPartner)) {
		// 		dispatch(setFilterGlobal({ partner: { id: findPartner.id, name: findPartner.name } }));
		// 	}

		// }
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [partners]);

	useEffect(() => {

		let temp = dossierState.dossiers;

		// if (!R.isNil(dossierState.globalFilters.type)) {
		// 	temp = temp.filter(user => user.status === dossierState.globalFilters.type);
		// }

		// if (dossierState.globalFilters.order.asc) {
		// 	temp = R.sort(R.ascend(R.prop(dossierState.globalFilters.order.column)), temp);
		// }

		// if (!R.isNil(dossierState.globalFilters.partner.id)) {
		// 	temp = temp.filter(user => user.partnerId === dossierState.globalFilters.partner.id);
		// }
		// if (!R.isEmpty(dossierState.globalFilters.search)) {
		// 	temp = temp.filter(user => user.firstName?.toLowerCase().includes(dossierState.globalFilters.search.toLowerCase()) || user.lastName?.toLowerCase().includes(dossierState.globalFilters.search.toLowerCase()));
		// 	//history.push(`/backoffice/dossiers?page=1&search=${dossierState.globalFilters.search}`);
		// }


		//setUsers(dossierState.globalFilters.order.asc ? R.sort(R.ascend(R.prop(dossierState.globalFilters.order.column)), temp) : R.sort(R.descend(R.prop(dossierState.globalFilters.order.column)), temp));

		setUsersToDisplay(temp);



		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dossierState.globalFilters, dossierState]);


	useEffect(() => {

		const filterForm = document.querySelector("#filterForm");
		const handleClick = (e) => {
			if (e.target.type === "button") {
				e.target.parentElement.classList.remove("show");
			}
		};
		const filterFormEvent = filterForm.addEventListener("click", handleClick);

		return () => filterForm.removeEventListener("click", handleClick);
	}, []);



	return (
		<article className="view-calc pt-3 mb-auto pb-sm pt-gd-3 pt-lg-4">
			<div className="container-fluid">
				<DossiersFilter dossierState={dossierState} statusOptions={statusOptionsRoute} searchRef={searchRef} pageSearch={pageSearch} setFilterGlobal={setFilterGlobal} setPageSearch={setPageSearch} partnersToDisplay={partnersToDisplay} routerQuery={routerQuery} />
			</div>
			<div className="auto-view h-100 mb-auto">
				{
					dossierState.isLoading.includes(Loadings.FETCHING_USERS_DOSSIERS) ?
						<LoadingState />
						:
						<div className="container-fluid">
							{!R.isEmpty(usersToDisplay) ?
								<section className="block grid-sm grid-sm-min grid-lg-narrow grid-hd-auto">
									{usersToDisplay.map(user => {
										let dossierTypeName = (user.createdByRepresentative ? "Facilita" : "Anticipa") + (user.hasDocumentSending ? "" : " light");
										if(user.createdByRepresentative && !user.hasDocumentSending && user.isSerenita){
											dossierTypeName = "Serenita";
										}
										return (
											<div className="card text-center h-100 rounded shadow--hover" key={user.id}>
												<div className="card-body my-auto px-3 flex-column">
													{/* <div className="card-body pt-3 pb-2 shadow h-100 rounded mb-2 text-center"> */}
													<Link to={`/backoffice/dossiers/${user.id}`} className="flex-column my-auto">
														<h4 className="h3 ls-n1 font-weight-black mt-auto mb-2 text-capitalize">
															{user.firstName} {user.lastName}
														</h4>
														<p className="h6 text-uppercase font-weight-bolder mb-0">
															<span className="o-40">{dossierTypeName}</span>
															{user.hasHrDocuments ? <span className="badge fs-1 bg-info text-white lj-1 px-2 py-1 align-middle ml-1">RH</span> : ""}
															{user.selfcareId ? <span className="badge fs-1 bg-info text-white lj-1 px-2 py-1 align-middle ml-1">EF</span> : ""}
														</p>
													</Link>
												</div>
												{partnersToDisplay && partnersToDisplay.find((partner) => partner.id === user.partnerId)?.name ? (
													<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder py-1 bg-light">
														<span className="o-60">Partner: </span>
														<span className="text-uppercase mx-1">
															{partnerState.isLoading.includes(Loadings.FETCHING_PARTNERS_DOSSIERS) ? <div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div> : partnersToDisplay && partnersToDisplay.find((partner) => partner.id === user.partnerId)?.name}
														</span>
													</div>
												) : (
													""
												)}

												<div className="card-footer alin-items-center border-light px-2 bg-none">
													<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder">
														<span className="o-60">Statut: </span>
														{/* <span className="text-success text-uppercase mx-1">{statusOptions[user.status]}</span> */}
														{statusOptions[user.status] === statusOptions.notStarted && <span className="text-warning text-uppercase mx-1">{statusOptions[user.status]}</span>}
														{/* {statusOptions[user.status] === statusOptions.notAccepted && <span className="text-info text-uppercase mx-1">{statusOptions[user.status]}</span>} */}
														{statusOptions[user.status] === statusOptions.ongoing && <span className="text-success text-uppercase mx-1">{statusOptions[user.status]}</span>}
														{statusOptions[user.status] === statusOptions.finished && <span className="text-info text-uppercase mx-1">{statusOptions[user.status]}</span>}
														{statusOptions[user.status] === statusOptions.sending && <span className="text-info text-uppercase mx-1">{statusOptions[user.status]}</span>}
														{/* {statusOptions[user.status] === statusOptions.archived && <span className="text-info text-uppercase mx-1">{statusOptions[user.status]}</span>} */}
														{statusOptions[user.status] === statusOptions.overtime && <span className="text-danger text-uppercase mx-1">{statusOptions[user.status]}</span>}
														{statusOptions[user.status] !== statusOptions.notStarted &&
															statusOptions[user.status] !== statusOptions.notAccepted &&
															statusOptions[user.status] !== statusOptions.ongoing &&
															statusOptions[user.status] !== statusOptions.finished &&
															statusOptions[user.status] !== statusOptions.sending &&
															statusOptions[user.status] !== statusOptions.overtime && <span className="text-uppercase mx-1">{statusOptions[user.status]}</span>}
													</div>
												</div>
											</div>
										);
									}
									)}
									{/* <div className="card card-body pt-3 pb-2 shadow h-100 rounded mb-2 text-center">
							<Link to="/backoffice/dossiers/:user" className="flex-column my-auto">
								<h4 className="h3 ls-n1 font-weight-black mt-auto mb-2">Vallis Lajoie</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mb-0">Facilita</p>
							</Link>
							<hr className="mx-nsm" />
							<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder">
								<span className="o-60">Statut: </span>
								<span className="text-success text-uppercase mx-1">En cours</span>
							</div>
						</div>
						<div className="card card-body pt-3 pb-2 shadow h-100 rounded mb-2 text-center">
							<Link to="/backoffice/dossiers/:user" className="flex-column my-auto">
								<h4 className="h3 ls-n1 font-weight-black mt-auto mb-2">Catwoman</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mb-0">Facilita</p>
							</Link>
							<hr className="mx-nsm" />
							<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder">
								<span className="o-60">Statut: </span>
								<span className="text-success text-uppercase mx-1">En cours</span>
							</div>
						</div>
						<div className="card card-body pt-3 pb-2 shadow h-100 rounded mb-2 text-center">
							<Link to="/backoffice/dossiers/:user" className="flex-column my-auto">
								<h4 className="h3 ls-n1 font-weight-black mt-auto mb-2">Batman</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mb-0">Anticipa</p>
							</Link>
							<hr className="mx-nsm" />
							<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder">
								<span className="o-60">Statut: </span>
								<span className="text-info text-uppercase mx-1">En terminé</span>
							</div>
						</div>
						<div className="card card-body pt-3 pb-2 shadow h-100 rounded mb-2 text-center">
							<Link to="/backoffice/dossiers/:user" className="flex-column my-auto">
								<h4 className="h3 ls-n1 font-weight-black mt-auto mb-2">Batman</h4>
								<p className="h6 text-uppercase o-40 font-weight-bolder mb-0">Anticipa</p>
							</Link>
							<hr className="mx-nsm" />
							<div className="flex-row fs-2 mx-auto mb-auto justify-content-center w-100 font-weight-bolder">
								<span className="o-60">Statut: </span>
								<span className="text-warning text-uppercase mx-1">En cloture</span>
							</div>
						</div> */}

								</section>
								:
								<div className="flex-column p-3 mt-5 h-100 ">
									<div className="container container-base text-center m-auto">
										<h5 className="sr-only visually-hidden">Agent - Empty</h5>
										<div className="display-4 font-weight-black ls-n1 lh-1 mb-3">On dirait <br />qu'il est vide.</div>
										<p className="text-lg mb-4 o-66">Malheureusement, nous ne parvenons pas à trouver le contenu que vous recherchez.</p>
									</div>
								</div>
							}
						</div>}
				{/* <EnvoisProfile /> */}
			</div>
			<div className="container-fluid">
				<DossiersPagination dossierState={dossierState} pageSearch={pageSearch} routerQuery={routerQuery} />
			</div>
		</article>
	);
};